import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import DetailItemRoles from '../DetailItem/DetailItemRoles';
import { IUserEditState } from '../utils';
import DetailItem from '../DetailItem/DetailItem';
import CustomAccordion from '../../../../common/components/CustomAccordion/CustomAccordion';

interface Params {
  userState: IUserEditState;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
  canEditUser: boolean;
}

const UserProfil: FC<Params> = (props) => {
  const { canEditUser, userState, setUserState } = props;

  return (
    <CustomAccordion title="Profil">
      <Grid container>
        <DetailItemRoles
          editable={canEditUser}
          userState={userState}
          setUserState={setUserState}
        />
        <DetailItem<IUserEditState>
          mutationVariableName="function"
          name="Fonction"
          value={userState.function}
          editable={canEditUser}
          setUserState={setUserState}
        />
      </Grid>
    </CustomAccordion>
  );
};

export default UserProfil;
